<template>
  <div class="content">
    <div class="left">
      <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e93733cc3c/703159668.png"
        alt=""
      />
    </div>
    <div class="right">
      <div class="headline">- 作答区域 -</div>
      <div class="title">拖拽图片或文字内容到指定内容区域</div>
      <div class="darg">
        <img
          src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9f56ce065/327733100.png"
          alt=""
          draggable="true"
          v-if="!dargImg"
        />
        <div @drop="drop" @dragover.prevent>
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9e01627de/501694418.png"
            alt=""
          />
          <span>拖拽到此处</span>
        </div>
        <img
          src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9f56ce065/327733100.png"
          alt=""
          draggable="true"
          v-if="dargImg"
        />
      </div>
      <div class="next" @click="go">下一题</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dargImg: false
    };
  },
  methods: {
    drop(e) {
      this.dargImg = !this.dargImg
    },
    go() {
      this.$router.push({
        name: 'educationRecord'
      })
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  .left {
    width: 45%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9378b4f7a/606856192.png);
    background-size: 100% 100%;
    padding: 4% 2%;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
  .right {
    width: 55%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e98747c556/505248194.png);
    background-size: 100% 100%;
    .headline {
      width: 100%;
      padding-top: 34px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #2144ff;
      line-height: 25px;
    }
    .title {
      margin-top: 44px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
      margin-left: 38px;
    }
    .desc {
      font-size: 16px;
      font-weight: 400;
      color: #383838;
      line-height: 26px;
      margin-left: 38px;
      margin-top: 6px;
    }
    .tip {
      padding-top: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #666d73;
      margin-left: 38px;
      line-height: 22px;
    }
    .darg {
      width: 100%;
      padding: 0 27px;
      box-sizing: border-box;
      margin-top: 44px;
      height: 255px;
      display: flex;
      justify-content: space-between;
      > img {
        width: 45%;
        height: 100%;
      }
      > div {
        width: 45%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9dfe8a097/787886936.png);
        background-size: 100% 100%;
        img {
          width: 50px;
        }
        span {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 24px;
          padding-top: 16px;
        }
      }
    }
    .next {
      width: 269px;
      height: 44px;
      background: #f8f9ff;
      border-radius: 6px;
      border: 1px solid #4594fb;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #4594fb;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 37px;
      cursor: pointer;
    }
  }
}
</style>
